import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import FormMaking from '../lib/form-making-advanced'
import '../lib/form-making-advanced/dist/FormMaking.css'
import allMethods from "../src/assets/allMethods";


Vue.use(ElementUI)
Vue.use(FormMaking)
Vue.config.productionTip = false
Vue.prototype.$http = axios
// 关闭 点击遮罩关闭弹出层 功能
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.prototype.$allMethods = allMethods


//请求拦截
axios.interceptors.request.use(
  config => {
    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = "bearer " + `${token}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

// 导航守卫


//响应拦截
// axios.interceptors.response.use(function (res) {
//   // console.log(res)
//   let code = res.data.code
//   if (code == 70001) {
//     // console.log(code)
//     sessionStorage.removeItem("token");
//     router.push("/");
//     return Promise.reject('error')
//   }
//   // else{
//   // return res;

//   // }
//   return res
// }, (err => {
//   console.log(err)
// }));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
